import React, {useState, useEffect} from 'react';
import {Formik, Field, Form} from 'formik';
import {TextField, Loading, GroupCheckBox, TextArea} from 'components/form';
import {required, validationWrapper, number, minLength, maxLength, email} from 'lib/formValidations';
import {transformTranslateFromValues} from 'lib/helpers';
import {useCore} from 'store/core'
import {Link, useNavigate} from "react-router-dom";
import {useList} from "store/list";
import {handleSuccessMessages} from "store/auth";

// components

export default function Add(props) {

    const path = {
        baseRoute: '/panel/roles',
        aliasName: 'نقش ها',
        type: 'Users',
    };
    const navigator = useNavigate();
    const {dispatch, clear, create} = useList();
    const core = useCore();
    useEffect(() => {
        core.dispatch(core.getAbilities());
    }, [])

    return (
        <>
            <div className="content">
                <div className="p-3">
                    <Formik
                        initialValues={{}}
                        onSubmit={async (values, {setSubmitting}) => {
                            await dispatch(create(path, (transformTranslateFromValues(values)), () => {
                                handleSuccessMessages("عملیات با موفقیت انجام شد")
                                navigator('/users/roles');
                            }));

                            setSubmitting(false);
                        }}
                        enableReinitialize
                    >
                        {({isSubmitting, dirty}) => (
                            <Form>
                                <div className="flex justify-between items-center">
                                    <h2>ایجاد نقش</h2>
                                    <Link to="/users/roles">
                                        <a className="btn btn-info shadow-md mr-2">بازگشت</a>
                                    </Link>
                                </div>
                                <hr className="my-3"/>
                                <div className="box rounded py-3">
                                    <div className="p-3">
                                        <div className="intro-x md:grid md:grid-cols-3 md:gap-3">
                                            <Field
                                                placeholder="نام"
                                                label="نام :"
                                                name="name"
                                                component={TextField}
                                                validate={(value) => validationWrapper(value, required)}
                                            />
                                            <Field
                                                placeholder="name"
                                                label="عنوان نمایشی :"
                                                name="display_name"
                                                component={TextField}
                                                validate={(value) => validationWrapper(value, required)}
                                            />
                                            <Field
                                                label="توضیحات :"
                                                name="desc"
                                                component={TextArea}
                                            />
                                            <Field
                                                label="دسترسی ها :"
                                                name="abilities"
                                                component={GroupCheckBox}
                                                options={core.abilities || []}
                                            />
                                        </div>
                                    </div>
                                    <div className="block text-start px-5">
                                        <button className="btn btn-primary shadow-md ml-5" type="submit"
                                                disabled={!!(isSubmitting || !dirty)}> {isSubmitting ?
                                            <Loading/> : 'ایجاد نقش'}</button>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </>
    );
}
